const ms = {};

export default ms;
